import { API_URL } from "_lib/utils";
import { UserAtom } from "_states";
import axios from "axios";
import { useRecoilState } from "recoil";

export const useProductActions = () => {
  const baseUrl = `${API_URL}`;
  const [user, setUser] = useRecoilState(UserAtom);

  const discoverSmallcases = async () => {
    return axios.get(`${baseUrl}/smallcase/discover`, {
      headers: { "X-Token": user.token },
    });
  };

  const buySmallcase = async (
    action: string,
    scid: string,
    iscid?: string,
    notes?: string
  ) => {
    return await axios.post(
      `${baseUrl}/smallcase/transaction`,
      {
        orderConfig: {
          type: action,
          scid: scid,
          iscid: iscid,
        },
        notes: notes,
      },
      {
        headers: { "X-Token": user.token },
      }
    );
  };

  return {
    discoverSmallcases,
    buySmallcase,
  };
};
